import React, { FC, useEffect, useState } from "react"
import { Button, message, Modal } from "antd"
import { LogoutOutlined } from "@ant-design/icons"
import { useHistory } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { useLogoutMutation } from "../../generated/graphql"
import { URL_BASE, URL_BOOKING } from "../../models/url"
import { red } from "@ant-design/colors"
import { safeStorage } from "../../helpers/safeStorage"
import { LOGOUT_STORAGE_KEYS } from "../../helpers/authStorageKeys"

// const LOGOUT_USER = gql`
//     mutation Logout {
//         logoutUser
//     }
// `

type LogoutProps = {
    style?: React.CSSProperties
    forceRefresh: () => void
}
const Logout: FC<LogoutProps> = ({ style, forceRefresh }) => {
    const history = useHistory()
    const { t } = useTranslation()
    const [isLoggedIn, setIsLoggedIn] = useState(false)
    const [logoutLoading, setLogoutLoading] = useState(false)
    // const [logoutUser] = useMutation(LOGOUT_USER)
    const [logoutUser] = useLogoutMutation()
    useEffect(() => {
        const isUserLoggedIn = !!safeStorage.getItem("loggedInUser")
        setIsLoggedIn(isUserLoggedIn)
        // Clean-up sollte den original Zustand wiederherstellen
        return () => {
            setIsLoggedIn(isUserLoggedIn)
        }
    }, [])

    const logout = async () => {
        setLogoutLoading(true)
        try {
            const { data } = await logoutUser()
            if (data?.logoutUser) {
                // Vollständige Aufräumliste (Session + Buchungskontext) — auf
                // gemeinsam genutzten Geräten darf nichts zurückbleiben.
                LOGOUT_STORAGE_KEYS.forEach((item) => safeStorage.removeItem(item))
                // Dispatch custom event für localStorage-Änderungen im App.tsx
                window.dispatchEvent(new Event("localStorageChange"))
                setIsLoggedIn(false)
                forceRefresh()
                // Kein harter Reload (history.go(0)) mehr — der zerstörte den gesamten
                // App-Zustand. App.tsx reagiert über das localStorageChange-Event auf den
                // geänderten Login-Status, hier reicht die Navigation zur Startseite.
                history.push(URL_BASE)
            } else {
                // Server hat den Logout NICHT bestätigt: Nutzer bleibt eingeloggt —
                // das muss sichtbar sein (Shared-Device-Risiko bei stillem Scheitern).
                message.error(t("logout.failed", "Abmelden fehlgeschlagen. Bitte versuche es erneut."))
            }
        } catch (error) {
            console.error("Logout error:", error)
            message.error(t("logout.failed", "Abmelden fehlgeschlagen. Bitte versuche es erneut."))
        } finally {
            setLogoutLoading(false)
        }
    }

    const handleLogoutClick = () => {
        // Im Buchungs-Flow geht die laufende Buchung beim Abmelden verloren —
        // deshalb dort vorher nachfragen. Außerhalb davon direkt abmelden.
        if (history.location.pathname.startsWith(URL_BOOKING)) {
            Modal.confirm({
                title: t("logout.confirmTitle", "Wirklich abmelden?"),
                content: t("logout.confirmContent", "Wenn du dich jetzt abmeldest, geht deine laufende Buchung verloren."),
                okText: t("logout.confirmOk", "Abmelden"),
                cancelText: t("logout.confirmCancel", "Abbrechen"),
                okButtonProps: { danger: true },
                onOk: logout,
            })
            return
        }
        logout()
    }

    return (
        <>
            {isLoggedIn && (
                <div style={style}>
                    <Button
                        size='small'
                        shape='round'
                        /* type='link' */ style={{ color: red[2], borderColor: red[1] }}
                        onClick={handleLogoutClick}
                        loading={logoutLoading}
                        data-testid='logout-button'
                    >
                        abmelden
                        <LogoutOutlined />
                    </Button>
                </div>
            )}
        </>
    )
}
export default Logout
